export default __webpack_public_path__ + "static/12-3--2a60aafe0355c0480cb9f3c7c85482f7.png";